import { ApiBase } from '../api.js';

export class ApiKey_value extends ApiBase {
	async create(data: unknown): Promise<unknown> {
		const result = await this.api.post('/key_value', data);
		return result.data;
	}

	async read(data): Promise<unknown> {
		const result = await this.api.get(`kv/type/${data}`);
		return result.data;
	}
	async readData(data): Promise<unknown> {
		const result = await this.api.get('kv/type', {
			params: {
				...data
			}
		});
		return result.data;
	}
	async update(data: unknown): Promise<unknown> {
		const result = await this.api.put('/key_value', data);
		return result.data;
	}

	async delete(data: unknown): Promise<unknown> {
		const result = await this.api.delete('/key_value', data);
		return result.data;
	}

	async getJurisdictionTypes(): Promise<unknown> {
		const result = await this.api.get('/kv/type/JURISDICTION_TYPE');
		return result.data;
	}
}
